"use client";

import {
  ChordPracticeGrid,
  ChordPracticeTempo,
} from "@/components/ui/organisms/chord-practice";

import { useChordsContext } from "./chords-context";
import { ChordsOverlayList } from "./chords-overlay-list";

/**
 * Overlay central du mode Chords. Branché sur `useChordsContext` :
 * la progression et la sélection vivent dans `ChordsProvider`.
 *
 * - Pas d'accord sélectionné → liste de catalogue.
 * - Accord + mode static → drill grille (`ChordPracticeGrid`).
 * - Accord + mode tempo  → drill tempo (`ChordPracticeTempo`).
 */
export function ChordsOverlay() {
  const {
    currentEntry,
    currentDone,
    practiceMode,
    setPracticeMode,
    markDone,
    selectEntry,
    closePractice,
  } = useChordsContext();

  if (!currentEntry) {
    return <ChordsOverlayList onSelect={selectEntry} />;
  }

  if (practiceMode === "static") {
    return (
      <ChordPracticeGrid
        entry={currentEntry}
        done={currentDone}
        onMarkDone={(posId) => markDone(currentEntry.id, posId)}
        mode={practiceMode}
        onModeChange={setPracticeMode}
        onClose={closePractice}
        onSelectVariant={selectEntry}
      />
    );
  }

  return (
    <ChordPracticeTempo
      entry={currentEntry}
      staticDone={currentDone.size}
      mode={practiceMode}
      onModeChange={setPracticeMode}
      onClose={closePractice}
    />
  );
}
